import type { DifferentProps } from '@/components/claims/Different';
import type { HeroProps } from '@/components/claims/Hero';
import type { HowItWorksProps } from '@/components/claims/HowItWorks';
import type { ReviewsProps } from '@/components/claims/Reviews';
import type { StatsProps } from '@/components/claims/Stats';
import { sharedConfig } from '@/pageConfig/shared';
import approvalImg from '@/static/claims/reddish/lemonade-claims-approval-process.png';
import aiImg from '@/static/claims/reddish/lemonade-claims-chatbot-ai.png';
import chatImg from '@/static/claims/reddish/lemonade-claims-chatbot.png';
import buttonImg from '@/static/claims/reddish/lemonade-claims-lemonade-app.png';
import type { BasePageConfig } from '../../BasePageConfig';
import { config as enUsConfig } from '../us/en';

export interface Config extends BasePageConfig {
  hero: HeroProps;
  stats: StatsProps;
  howItWorks: HowItWorksProps;
  reviews: ReviewsProps;
  different: DifferentProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-DE'].layout },
  seo: { ...enUsConfig.seo, title: '', metaTitle: '', description: '' },
  hero: { ...enUsConfig.hero },
  howItWorks: {
    ...enUsConfig.howItWorks,
    steps: {
      ...enUsConfig.howItWorks.steps,
      claim_button: {
        ...enUsConfig.howItWorks.steps.claim_button,
        image: buttonImg,
      },
      what_happened: {
        ...enUsConfig.howItWorks.steps.what_happened,
        image: chatImg,
      },
      anti_fraud: {
        ...enUsConfig.howItWorks.steps.anti_fraud,
        image: aiImg,
      },
      instantly_approved: {
        ...enUsConfig.howItWorks.steps.instantly_approved,
        image: approvalImg,
      },
      humans: {
        ...enUsConfig.howItWorks.steps.humans,
        image: approvalImg,
      },
    },
  },
  stats: { ...enUsConfig.stats },
  reviews: { ...enUsConfig.reviews, showVideo: false },
  different: { ...enUsConfig.different, title: 'Paying Claims. Doing Good' },
};
